// extracted by mini-css-extract-plugin
export default {"snackbar":"Snackbar_snackbar__S2MY-"};